import { default as livestage } from ":src/modules/livestage/routes";
import { default as mentors } from ":src/modules/learning-portal/mentors/routes";
import { default as resources } from ":src/modules/learning-portal/resources/routes";
import { default as workshops } from ":src/modules/learning-portal/workshops/routes";
import { default as agenda } from ":src/modules/schedule/agenda/routes";
import { default as myteam } from ":src/modules/teaming/my-team/routes";
import { default as participants } from ":src/modules/teaming/participants/routes";
import { default as project_submission } from ":src/modules/teaming/project-submission/routes";
import { default as exhibition } from ":src/modules/teaming/exhibition/routes";
import { default as faq_inquiry } from ":src/modules/help-portal/faq-inquiry/routes";
import { default as profile } from ":src/modules/account/profile/routes";
export default {
  BASE: "/participant",
  profile,
  livestage,
  agenda,
  myteam,
  participants,
  project_submission,
  exhibition,
  mentors,
  resources,
  workshops,
  faq_inquiry,
};
